export class SoComparisonDetails{
    finYear: string;
    finMonth: string;
    plantCode: string;
    openSos: string;
    closesSos: string;
    cancelledSos: string;
  }